import { Handle, Position } from 'reactflow';
import { useState, useEffect } from 'react';
import './ConditionNode.css';

export default function ConditionNode({ data }) {
  const [conditions, setConditions] = useState(
    data.conditions || [{ field: 'status', operator: 'equals', value: 'Closed', logic: 'AND' }]
  );
  const [activePath, setActivePath] = useState(data.active || null);
  const [fields, setFields] = useState(data.fields || []);

  useEffect(() => {
    setFields(data.fields || []);
  }, [data.fields]);



  useEffect(() => {
    data.conditions = conditions;
    data.active = activePath;
  }, [conditions, activePath]); 


  const addCondition = () => {
    setConditions([...conditions, { field: '', operator: 'equals', value: '', logic: 'AND' }]);
  };

  const updateCondition = (index, key, value) => {
    const newConditions = [...conditions];
    newConditions[index][key] = value;
    setConditions(newConditions);
  };

  const toggleActive = (path) => setActivePath(path);

  return (
    <div className="condition-node">
      {/* Remove Node Button */}
      {data.onRemove && (
        <button
          onClick={data.onRemove}
          style={{
            position: 'absolute',
            top: 4,
            right: 4,
            background: 'red',
            color: 'white',
            border: 'none',
            borderRadius: 4,
            fontSize: 10,
            padding: '2px 4px',
            cursor: 'pointer',
            zIndex: 10,
          }}
        >
          X
        </button>
      )}

      <strong>Condition</strong>

      <div className="conditions-container">
      {conditions.map((cond, i) => (
        <div key={i} className="single-condition">
          {i > 0 && (
            <select
              value={cond.logic}
              onChange={(e) => updateCondition(i, 'logic', e.target.value)}
              className="logic-select"
            >
              <option value="AND">AND</option>
              <option value="OR">OR</option>
            </select>
          )}

          {/* Field dropdown */}
          <select
            value={cond.field}
            onChange={(e) => updateCondition(i, 'field', e.target.value)}
            className="condition-select"
          >
            <option value="">Select Field</option>
            {fields.map((f) => (
              <option key={f} value={f}>{f}</option>
            ))}
          </select>

          <select
            value={cond.operator}
            onChange={(e) => updateCondition(i, 'operator', e.target.value)}
            className="operator-select"
          >
            <option value="equals">=</option>
            <option value="not_equals">!=</option>
            <option value=">">&gt;</option>
            <option value="<">&lt;</option>
          </select>

          <input
            type="text"
            placeholder="Value"
            value={cond.value}
            onChange={(e) => updateCondition(i, 'value', e.target.value)}
            className="condition-input"
          />
        </div>
      ))}


        {/* Small + Condition button with margin */}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 8, marginBottom: 28 }}>
          <button
            onClick={addCondition}
            style={{
              fontSize: 10,
              padding: '2px 6px',
              borderRadius: 4,
              backgroundColor: '#fbbf24',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            + Condition
          </button>
        </div>
      </div>

      {/* Handles */}
      <Handle type="target" position={Position.Top} style={{ background: '#555' }} />
      <Handle
        type="source"
        id="yes"
        position={Position.Bottom}
        style={{
          left: 35,
          bottom: 4,
          background: activePath === 'yes' ? 'green' : 'gray',
          width: 10,
          height: 10,
          borderRadius: '50%',
        }}
        onClick={() => toggleActive('yes')}
      />
      <Handle
        type="source"
        id="no"
        position={Position.Bottom}
        style={{
          left: 155,
          right: 45,
          bottom: 4,
          background: activePath === 'no' ? 'red' : 'gray',
          width: 10,
          height: 10,
          borderRadius: '50%',
        }}
        onClick={() => toggleActive('no')}
      />

      {/* Yes/No labels */}
      <div className="bottom-labels">
        <span className={activePath === 'yes' ? 'active-label' : ''}>Yes</span>
        <span className={activePath === 'no' ? 'active-label' : ''}>No</span>
      </div>
    </div>
  );
}
